export default __webpack_public_path__ + "static/media/icons-grc-questions.966a4081.svg";